import qwest from 'qwest';

import CustomerNote from '../models/customerNote.jsx';

import CustomerApi from './customer.jsx';

let NotesApi = {
  getList(customerID) {
    return new Promise((resolve, reject) => {
      qwest.get(`/CustomerNotes/List?customerID=${customerID}`)
        .then((xhr, response) => {
          if (response.success) {
            let notes = response.data.map(n => CustomerNote.fromApiFormat(n));

            resolve(notes);
          } else {
            reject(response);
          }
        });
    });
  },

  save(note, customerID, invalidateCache = true) {
    return new Promise((resolve, reject) => {
      qwest.post('/CustomerNotes', {note: note.toApiFormat()})
        .then((xhr, response) => {
          if (response.success) {
            let notes = response.data.map(n => CustomerNote.fromApiFormat(n));

            if (invalidateCache) {
              CustomerApi.getCustomer(customerID);
            }
            resolve(notes);
          } else {
            reject(response);
          }
        });
    });
  },

};

export default NotesApi;
